import React, { useState } from 'react';
import { User, ArrowRight } from 'lucide-react';
import logo from "../images/logo.png";
import AutoCadastroService from '../../modules/services/AutoCadastroService';
import '../css/login.css';

function EsqueciSenha() {
    // Pré-preenche quando vem do login com senha expirada (ver login.js), que linka pra cá como
    // "/esqueci-senha?login=...". Esta tela é renderizada fora do Router (ver ROTAS_PUBLICAS em
    // App.js), então lê a query string direto da URL, sem useSearchParams.
    const loginPreenchido = new URLSearchParams(window.location.search).get('login') || '';
    const [login, setLogin] = useState(loginPreenchido);
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState('');
    const [mensagem, setMensagem] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!login.trim()) {
            setErro('Informe seu login.');
            return;
        }

        setErro('');
        setCarregando(true);
        try {
            const resposta = await AutoCadastroService.esqueciSenha(login.trim());
            setMensagem(resposta);
        } catch (error) {
            setErro(error.message || 'Não foi possível processar a solicitação.');
        } finally {
            setCarregando(false);
        }
    };

    return (
        <main className="login-page">
            <aside className="login-brand-panel">
                <div className="login-brand-mark">
                    <span className="login-wordmark">
                        <img src={logo} alt="Logo" className="logo" />
                    </span>
                </div>
                <div className="login-brand-headline">
                    <h1>Esqueceu sua senha?</h1>
                    <p>Informe seu login e enviaremos um link para redefinição por e-mail.</p>
                </div>
            </aside>

            <section className="login-form-panel">
                <div className="login-form-wrap">
                    {mensagem ? (
                        <div className="login-form-header">
                            <h2>Verifique seu e-mail</h2>
                            <p>{mensagem}</p>
                            <a href="/">Voltar para o login</a>
                        </div>
                    ) : (
                        <>
                            <div className="login-form-header">
                                <h2>Esqueci minha senha</h2>
                                <p>Informe o login da sua conta.</p>
                            </div>

                            <form className="login-form" onSubmit={handleSubmit} noValidate>
                                <div className="login-field">
                                    <label htmlFor="login-esqueci">Login</label>
                                    <div className="login-input-wrap">
                                        <User className="login-ico-lead" size={18} />
                                        <input
                                            id="login-esqueci"
                                            type="text"
                                            value={login}
                                            onChange={(event) => setLogin(event.target.value)}
                                            disabled={carregando}
                                        />
                                    </div>
                                </div>

                                {erro && <div className="login-erro">{erro}</div>}

                                <button type="submit" className="login-btn-submit" disabled={carregando}>
                                    {carregando ? 'Enviando...' : 'Enviar link'}
                                    <ArrowRight size={16} />
                                </button>
                            </form>

                            <div className="login-help-block">
                                <a href="/">Voltar para o login</a>
                            </div>
                        </>
                    )}
                </div>
            </section>
        </main>
    );
}

export default EsqueciSenha;
